var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBadge)?_c('div',{staticClass:"offer-more-content",style:(_vm.mergedStyle)},[_c('span',{staticClass:"more-content-number"},[_vm._v(_vm._s(_vm.moreContentValue)+"%")]),_c('span',{staticClass:"more-content-text"},[_vm._v(_vm._s(_vm.$t("shop.offers.more_contents2")))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }